import { RefreshCw } from 'lucide-react';
import type { GoalTaskBlock } from '@/entities/chat-message';
import { useGoalsByIds } from '@/queries/goal';

interface RevisedTaskLineProps {
  task: GoalTaskBlock;
}

export function RevisedTaskLine({ task }: RevisedTaskLineProps) {
  const { goals } = useGoalsByIds([task.data.parentGoalId], {
    source: 'RevisedTaskLine.parentGoal',
  });
  const parentGoal = goals?.[0];

  return (
    <span className="text-xs text-gray-500">
      <RefreshCw className="inline h-3.5 w-3.5 align-[-0.15em]" /> Revised
      suggestion
      {parentGoal ? (
        <>
          {' '}
          for{' '}
          <span className="font-medium text-gray-700">{parentGoal.title}</span>
        </>
      ) : null}
    </span>
  );
}
